import { IShader, ShaderBase } from '../shader';
import { Material, Scene, PBRMetallicRoughnessMaterial, Texture } from '@babylonjs/core';
import { stringUtil } from '@/models/stringUtil';

export class ShaderFloorFrame extends ShaderBase implements IShader {

    public diffuse: string = '';
    public normal: string = '';
    public avatar: string = 'bed3_icon.png';
    public text: string = 'floorFrame';
    public key: string = 'ShaderFloorFrame';

    public getMaterial(scene: any): Material {
        return new Material('', scene);
    }

    addLight(scene: Scene, material: Material, light: string): Material {
        return material;
    }
}